import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/shared/components';

interface MappingIframeDialogProps {
  iframeUrl: string | null;
  onOpenChange: (open: boolean) => void;
}

export function MappingIframeDialog({ iframeUrl, onOpenChange }: MappingIframeDialogProps) {
  return (
    <Dialog open={iframeUrl !== null} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-5xl">
        <DialogHeader>
          <DialogTitle>Channex Channel-Mapping</DialogTitle>
          <DialogDescription>
            Channex's eingebettete Mapping-UI. Session läuft 15 Min, dann hier neu öffnen.
          </DialogDescription>
        </DialogHeader>
        <DialogBody>
          {iframeUrl && (
            <iframe
              src={iframeUrl}
              title="Channex Mapping"
              className="border-line h-150 w-full rounded-md border"
              sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox"
            />
          )}
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}
